// import svg4everybody from "svg4everybody"; SVG for Everybody adds SVG External Content support to all browsers.

// CUSTOM MODULES
import Configurator from "./modules/configurator";
import Map from "./modules/map";
import Navigation from "./modules/navigation";
import handleToast from "./modules/handleToast";
import Toggle from "./modules/toggle";
import Glide from '@glidejs/glide';

/**
 *  App class
 *
 *  The App class functions a the main back-bone of the javascript used in this
 *  project.
 *
 */

class App {
    /**
     *  Constructor
     */
    constructor() {
        document.addEventListener(
            "DOMContentLoaded",
            function() {
                this.onDocumentReady();
            }.bind(this)
        );
    }

    onDocumentReady() {
        new Configurator();
        new Navigation();
        new Toggle();
        new Map();

        const reviews = document.querySelector('.reviews');
        const heroImages = document.querySelector('.hero__images');
        const sliderImages = document.querySelector('.slider-images');
        const sliderText = document.querySelector('.slider-text');

        if (reviews) {
            new Glide(reviews, {
                type: 'carousel',
                autoplay: 6000,
                animationDuration: 0,
                startAt: 0,
            }).mount();
        }

        if (heroImages) {
            new Glide(heroImages, {
                type: 'carousel',
                autoplay: 6000,
                animationDuration: 0,
                startAt: 0,
            }).mount();
        }

        if (sliderImages) {
            if (document.querySelector('.slider-images .glide__slide')) {
                new Glide(sliderImages, {
                    type: 'carousel',
                    autoplay: 6000,
                    animationDuration: 0,
                    startAt: 0,
                }).mount();
            }
        }

        if (sliderText) {
            new Glide(sliderText, {
                type: 'carousel',
                autoplay: 6000,
                animationDuration: 0,
                startAt: 0,
            }).mount();
        }
    }

    initMap() {
        new Map();
    }

    handleToast(container, options) {
        new handleToast(container, options);
    }
}

window.app = new App();